import {
  DndContext,
  DndContextProps,
  DragEndEvent,
  DragOverEvent,
  PointerSensor,
  TouchSensor,
  closestCenter,
  useSensor,
  useSensors,
} from '@dnd-kit/core';
import React from 'react';

type DndContextComponentProps = {
  onDragEnd?: (event: DragEndEvent) => void;
  onDragOver?: (event: DragOverEvent) => void;
  children: React.ReactNode;
} & DndContextProps;

export const DNDContext: React.FC<DndContextComponentProps> = ({
  onDragEnd,
  onDragOver,
  children,
  ...props
}) => {
  const sensors = useSensors(
    useSensor(PointerSensor, {
      activationConstraint: {
        distance: 8,
      },
    }),
    useSensor(TouchSensor, {
      activationConstraint: {
        delay: 200,
        tolerance: 6,
      },
    }),
  );

  return (
    <DndContext
      sensors={sensors}
      collisionDetection={closestCenter}
      onDragEnd={onDragEnd}
      onDragOver={onDragOver}
      {...props}
    >
      {children}
    </DndContext>
  );
};
